var _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockstore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9079_32891)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9079_32891)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9079_32891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0.666016H0V32.2895H32V0.666016Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9079_32891)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9079_32891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0.666016H0V32.2895H32V0.666016Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9079_32891)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9079_32891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 32,
    height: 32
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 1.04297H0.376465V32.29H32V1.04297Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9079_32891)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9079_32891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 32,
    height: 32
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 1.04297H0.376465V32.29H32V1.04297Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9079_32891)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9079_32891",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 32,
    height: 32
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 1.04297H0.376465V32.29H32V1.04297Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9079_32891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3647 16.6661C29.3647 23.8566 23.4654 29.6857 16.1882 29.6857C8.91105 29.6857 3.01172 23.8566 3.01172 16.6661C3.01172 9.47558 8.91105 3.64648 16.1882 3.64648C23.4654 3.64648 29.3647 9.47558 29.3647 16.6661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 16.6665C32.0001 25.2951 24.9209 32.29 16.1883 32.29C7.45565 32.29 0.376465 25.2951 0.376465 16.6665C0.376465 8.03787 7.45565 1.04297 16.1883 1.04297C24.9209 1.04297 32.0001 8.03787 32.0001 16.6665Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2871 16.6673C30.2871 24.3612 23.9748 30.5983 16.1882 30.5983C8.40164 30.5983 2.08936 24.3612 2.08936 16.6673C2.08936 8.97346 8.40164 2.73633 16.1882 2.73633C23.9748 2.73633 30.2871 8.97346 30.2871 16.6673Z",
    fill: "#A50000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3647 16.6661C29.3647 23.8566 23.4654 29.6857 16.1882 29.6857C8.91105 29.6857 3.01172 23.8566 3.01172 16.6661C3.01172 9.47558 8.91105 3.64648 16.1882 3.64648C23.4654 3.64648 29.3647 9.47558 29.3647 16.6661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1854 17.4072L9.93677 13.5939L10.4931 12.7085L16.1912 16.1862L23.6433 11.6641L24.1937 12.5552L16.1854 17.4072Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7695 16.6659C17.7695 17.5287 17.0616 18.2282 16.1884 18.2282C15.3151 18.2282 14.6072 17.5287 14.6072 16.6659C14.6072 15.803 15.3151 15.1035 16.1884 15.1035C17.0616 15.1035 17.7695 15.803 17.7695 16.6659Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6272 6.25781L10.3245 5.85999L11.4533 7.79183L10.756 8.18965L9.6272 6.25781Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22876 10.8945L5.63137 10.2055L7.58648 11.3208L7.18387 12.0099L5.22876 10.8945Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76709 16.2871H6.02466V17.0828H3.76709V16.2871Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22876 22.4766L7.18387 21.3612L7.58649 22.0503L5.63137 23.1656L5.22876 22.4766Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62817 27.1172L10.757 25.1854L11.4543 25.5832L10.3255 27.515L9.62817 27.1172Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7842 26.7285H16.5894V28.9592H15.7842V26.7285Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9189 25.582L21.6164 25.1843L22.7448 27.1164L22.0474 27.5141L20.9189 25.582Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7886 22.0527L25.1911 21.3636L27.1464 22.4786L26.7439 23.1677L24.7886 22.0527Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3518 16.2871H28.6094V17.0828H26.3518V16.2871Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8831 11.3594L26.8471 10.244L27.2497 10.9362L25.2857 12.0516L24.8831 11.3594Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9185 7.79297L22.0472 5.86113L22.7446 6.25895L21.6158 8.19079L20.9185 7.79297Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5089 4.69728C15.4127 4.69667 15.3205 4.73541 15.2542 4.80432L14.7388 5.31063C14.5978 5.45063 14.5978 5.67697 14.7388 5.81698L16.2029 7.24911L17.667 5.81698C17.808 5.67697 17.808 5.45063 17.667 5.31063L17.1223 4.80432C17.056 4.73541 16.9638 4.69667 16.8676 4.69728C16.7708 4.69788 16.6781 4.73636 16.6099 4.80432L16.1883 5.22095L15.7666 4.80432C15.6992 4.73526 15.6061 4.69655 15.5089 4.69728Z",
    fill: "#CC0000"
  }))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9079_32891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9079_32891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.6235,
    fill: "white",
    transform: "translate(0 0.666016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockstore);
export default __webpack_public_path__ + "static/media/clockstore.74023f8fc51cecc818e3f0cde06dd228.svg";
export { ForwardRef as ReactComponent };